import { ObjectSvg } from '@bcl/drawing-control';

const mockBrandIcon = (brand: string): string => `
<svg fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="30" height="30" rx="13" fill="#fff"/>
  <rect x="1.5" y="1.5" width="26" height="27" rx="13" stroke="#1C1C1C" stroke-width="3"/>
  <text  y="24" font-family="Design System Icons" font-size="18px" fill="#000" x="5">${brand}-icon</text>
  <path d="M14.5 37L5 27H24L14.5 37Z" fill="#1C1C1C"/>
</svg>`;

export const areaMonitorsSvg: Record<string, ObjectSvg> = {
  mice: {
    content:
      // eslint-disable-next-line max-len
      '<svg fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.5" y="1.5" width="26" height="27" rx="13" fill="#fff"/><rect x="1.5" y="1.5" width="26" height="27" rx="13" stroke="#1C1C1C" stroke-width="3"/><path d="M9.16051 9.81818H11.4176L14.4403 17.196H14.5597L17.5824 9.81818H19.8395V20H18.0696V13.005H17.9751L15.1612 19.9702H13.8388L11.0249 12.9901H10.9304V20H9.16051V9.81818Z" fill="#000"/><path d="M14.5 37L5 27H24L14.5 37Z" fill="#1C1C1C"/></svg>',
    size: { width: 29, height: 37 },
  },
  action: {
    content: mockBrandIcon('zap'),
    size: { width: 29, height: 37 },
  },
  beetle: {
    content: mockBrandIcon('fumigation'),
    size: { width: 29, height: 37 },
  },
  bird: {
    content: mockBrandIcon('fauna-management'),
    size: { width: 29, height: 37 },
  },
} as const;
